import { css } from "@compiled/react";
import { defineMessages } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { Team24AdBanner } from "@/patterns/team-24-ad-banner";

const sectionStyles = css({
    backgroundColor: "#091E42",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 15px"
});

export const team24AdBannerMessages = defineMessages({
    team24LogoAlt: {
        id: "team-24-ad-banner.jira.team-24-logo.alt",
        defaultMessage: "team 24 logo"
    },
    adCopyTitle: {
        id: "team-24-ad-banner.jira.ad-copy.title",
        defaultMessage: "Our annual conference is back in Las Vegas!"
    },
    adCopyParagraph: {
        id: "team-24-ad-banner.jira.ad-copy.paragraph",
        defaultMessage:
            "Be the first to know about product updates coming to Jira at our biggest conference of the year, Team ’24."
    },
    callToActionText: {
        id: "team-24-ad-banner.jira.call-to-action.text",
        defaultMessage: "Register now"
    },
    callToActionIconLabel: {
        id: "team-24-ad-banner.jira.call-to-action.icon.label",
        defaultMessage: "right arrow icon"
    },
    rightHandImageAlt: {
        id: "team-24-ad-banner.jira.right-hand-image.alt",
        defaultMessage: "Atlassian President"
    }
});

const Team24AdBannerSection = () => {
    const { createAnalyticsEvent } = useAnalyticsEvents();

    return (
        <section css={sectionStyles}>
            <Team24AdBanner
                team24LogoAlt={team24AdBannerMessages.team24LogoAlt}
                team24LogoDesktopUrl={
                    "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-logo-desktop.webp-1192641009.webp"
                }
                adCopyTitle={team24AdBannerMessages.adCopyTitle}
                adCopyParagraph={team24AdBannerMessages.adCopyParagraph}
                callToActionUrl={
                    "https://events.atlassian.com/team?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=jsw_lifted_bar&utm_medium=web"
                }
                callToActionText={team24AdBannerMessages.callToActionText}
                callToActionIconLabel={
                    team24AdBannerMessages.callToActionIconLabel
                }
                onClickFunc={() => {
                    createAnalyticsEvent({
                        eventType: "ui",
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "wacTeam24AdBanner",
                        source: "/software/jira",
                        attributes: {
                            atlasId: "ATLAS-58441"
                        }
                    }).fire();
                }}
                backgroundStyle="jira"
            />
        </section>
    );
};

export default Team24AdBannerSection;
